// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-chip {
  min-width: 15px !important;
  min-height: 15px !important;
  height: 30px !important;
  padding: var(--spacing-xx-small);
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.chip-label {
  font-size: clamp(0.5rem, 1.6vmin, 0.75rem);
}

.filterContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 0;
}

.filterIonSelect {
  justify-content: center;
  align-items: center;
  --padding-start: var(--spacing-xx-small);
  --padding-end: var(--spacing-xx-small);
  --padding-top: 0;
  --padding-bottom: 0;
  --width: auto;
}

.filterIonSelect .popover-content {
  width: auto;
}

.centerContent {
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-outline {
  height: 70% !important;
  border: 1px solid var(--af-border-primary);
  border-radius: var(--af-radius-item);
  padding: 0 var(--spacing-xx-small);
  display: flex;
  align-items: center;
}

.filter-item-title {
  margin: 0 var(--spacing-xx-small);
  font-size: clamp(0.2rem, 1.8vmin, 0.9rem);
  color: black;
}

.apply-filter-button {
  height: 65% !important;
  border-radius: var(--af-radius-item);
  background-color: var(--ion-color-primary);
  margin-left: var(--spacing-xx-small);
  min-width: 38px !important;
  width: auto;
  padding: 0 var(--spacing-xx-small);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent !important;
  transition: all 0.3s ease;
  cursor: pointer;
  color: white !important;
}
.apply-filter-button ion-icon {
  color: white !important;
  font-size: 14px !important;
}
.apply-filter-button ion-label {
  color: white !important;
}
.apply-filter-button:hover {
  border: 2px solid var(--ion-color-primary) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  color: var(--ion-color-primary);
  background-color: white;
}
.apply-filter-button:hover ion-icon,
.apply-filter-button:hover ion-label {
  color: var(--ion-color-primary) !important;
}
.apply-filter-button:active {
  transform: scale(0.98);
}

.select-filter-button {
  opacity: 1;
  position: absolute;
  z-index: 990;
  width: auto;
  min-width: 45px !important;
  max-width: 150px;
  min-height: 15px !important;
  height: 100% !important;
  padding: 0 var(--spacing-xx-small) !important;
  right: var(--spacing-small);
  border-radius: var(--af-radius-section);
  background-color: var(--ion-color-primary);
  border: 2px solid transparent !important;
  margin-left: auto;
  margin-right: 0;
  transition: all 0.3s ease;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
}
.select-filter-button ion-icon {
  color: white !important;
  font-size: 22px !important;
}
.select-filter-button ion-label {
  color: white !important;
}
.select-filter-button:hover {
  border: 2px solid var(--ion-color-primary) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  color: var(--ion-color-primary);
  background-color: white;
}
.select-filter-button:hover ion-icon,
.select-filter-button:hover ion-label {
  color: var(--ion-color-primary) !important;
}
.select-filter-button:active {
  transform: scale(0.98);
}

option {
  color: var(--ion-color-primary);
  background-color: white;
  padding: 8px;
}

.custom-select-popover-filter,
.custom-select-popover-num-months-years,
.custom-select-popover-year {
  height: 70% !important;
  width: auto;
  background-color: white !important;
  color: var(--ion-color-primary) !important;
  border: 1px solid var(--ion-color-primary);
  border-radius: var(--af-radius-item);
  padding: 0 var(--spacing-xx-small);
  margin: 0 var(--spacing-xx-small) 0 var(--spacing-xx-small);
  font-size: clamp(0.2rem, 1.8vmin, 0.9rem);
}

.popover-filter-container {
  padding: var(--spacing-large);
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 0;
  gap: var(--spacing-medium);
  justify-content: space-between;
}
.popover-filter-container .filter-controls-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--spacing-xs);
  border-bottom: 1px solid #f0f0f0;
}
.popover-filter-container .filter-controls-row .filter-item-title {
  min-width: auto;
  max-width: none;
  color: var(--ion-color-primary);
  white-space: nowrap;
  overflow: visible;
  text-overflow: initial;
  font-size: clamp(0.8rem, 1.5vw, 1rem);
  margin: 0;
  flex-shrink: 0;
  font-weight: 500;
}
.popover-filter-container .filter-controls-row select {
  background-color: white;
  color: var(--ion-color-primary);
  border: 1px solid var(--ion-color-primary);
  border-radius: var(--af-radius-item);
  padding: var(--spacing-xs) var(--spacing-small);
  height: 44px;
  margin: 0;
  font-size: 1rem;
  min-width: 120px;
  flex-grow: 1;
  margin-left: var(--spacing-small);
}
.popover-filter-container .filter-button-row {
  display: flex;
  justify-content: center;
  padding-top: var(--spacing-xs);
  width: 100%;
}
.popover-filter-container .filter-button-row .apply-filter-button {
  height: 44px !important;
  border-radius: var(--af-radius-item);
  margin-top: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 var(--spacing-small) !important;
}
.popover-filter-container .filter-button-row .apply-filter-button .apply-filter-label {
  display: block !important;
  color: white;
  font-size: 0.9rem;
  margin: 0;
  padding: 0;
}

::ng-deep .filter-popover {
  --width: 100vw !important;
  --height: 100vh !important;
  --max-width: 100vw !important;
  --max-height: 100vh !important;
}
::ng-deep .filter-popover .popover-content {
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 800px) or (max-height: 550px) {
  .filterContainer {
    display: none;
  }
  .apply-filter-label {
    display: none;
  }
  .filter-item-title {
    max-width: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .chip-icon {
    margin: 0;
    height: 80%;
    width: 80%;
  }
  .select-filter-button {
    display: flex;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 800px) and (min-height: 550px) {
  .chip-icon {
    display: none !important;
  }
  .select-filter-button {
    display: none !important;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1000px) and (min-height: 600px) {
  .chip-icon {
    display: none !important;
  }
  .select-filter-button {
    display: none !important;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/pages/logbooks/components/logbooks-time-filter/logbooks-time-filter.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,gCAAA;EAEA,wBAAA;EACA,kCAAA;EACA,8BAAA;AAAJ;;AAGA;EACI,0CAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EAEA,YAAA;EACA,WAAA;EAEA,cAAA;EACA,iBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,uBAAA;EACA,mBAAA;EACA,wCAAA;EACA,sCAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AAFJ;;AAKA;EACI,WAAA;AAFJ;;AAKA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,sBAAA;EACA,0CAAA;EACA,oCAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,iCAAA;EACA,yCAAA;EACA,YAAA;AAFJ;;AAKA;EACI,sBAAA;EACA,oCAAA;EACA,0CAAA;EACA,oCAAA;EACA,0BAAA;EACA,WAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,yBAAA;EACA,eAAA;EACA,uBAAA;AAFJ;AAII;EACI,uBAAA;EACA,0BAAA;AAFR;AAKI;EACI,uBAAA;AAHR;AAMI;EACI,qDAAA;EACA,0CAAA;EACA,+BAAA;EACA,uBAAA;AAJR;AAMQ;;EAEI,0CAAA;AAJZ;AAQI;EACI,sBAAA;AANR;;AAUA;EACI,UAAA;EACA,kBAAA;EACA,YAAA;EAEA,WAAA;EACA,0BAAA;EACA,gBAAA;EACA,2BAAA;EACA,uBAAA;EACA,6CAAA;EAEA,2BAAA;EAEA,uCAAA;EACA,0CAAA;EACA,wCAAA;EAEA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAXJ;AAaI;EACI,uBAAA;EACA,0BAAA;AAXR;AAcI;EACI,uBAAA;AAZR;AAeI;EACI,qDAAA;EACA,0CAAA;EACA,+BAAA;EACA,uBAAA;AAbR;AAeQ;;EAEI,0CAAA;AAbZ;AAiBI;EACI,sBAAA;AAfR;;AAmBA;EACI,+BAAA;EACA,uBAAA;EACA,YAAA;AAhBJ;;AAmBA;;;EAGE,sBAAA;EACA,WAAA;EACA,kCAAA;EACA,0CAAA;EACA,0CAAA;EACA,oCAAA;EACA,kCAAA;EACA,2DAAA;EACA,yCAAA;AAhBF;;AAmBA;EACI,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,0BAAA;EACA,8BAAA;AAhBJ;AAkBE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,0BAAA;EACA,gCAAA;AAhBJ;AAkBI;EACE,eAAA;EACA,eAAA;EACA,+BAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAhBN;AAmBI;EACE,uBAAA;EACA,+BAAA;EACA,0CAAA;EACA,oCAAA;EACA,+CAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iCAAA;AAjBN;AAqBE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,WAAA;AAnBJ;AAqBI;EACE,uBAAA;EACA,oCAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;AAnBN;AAqBM;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;AAnBR;;AAyBA;EACI,yBAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;AAtBJ;AAwBI;EACI,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;AAtBR;;AA0BA,sEAAA;AAEA,wBAAA;AAEE,2DAAA;AACA;EACE;IACI,aAAA;EAzBN;EA4BE;IACI,aAAA;EA1BN;EA6BE;IACI,eAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EA3BN;EA8BE;IACI,SAAA;IACA,WAAA;IACA,UAAA;EA5BN;EA+BE;IACI,aAAA;EA7BN;AACF;AA+BA,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACA;EACE;IACI,wBAAA;EA/BN;EAkCE;IACI,wBAAA;EAhCN;AACF;AAmCA,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AACA;EACE;IACI,wBAAA;EAnCN;EAsCE;IACI,wBAAA;EApCN;AACF;AAuCA,4BAAA","sourcesContent":["ion-chip {\r\n    min-width: 15px !important;\r\n    min-height: 15px !important;\r\n    height: 30px !important;\r\n    padding: var(--spacing-xx-small);\r\n\r\n    display: flex !important;\r\n    justify-content: center !important;\r\n    align-items: center !important;\r\n}\r\n\r\n.chip-label {\r\n    font-size: clamp(0.5rem, 1.6vmin, 0.75rem);\r\n}\r\n\r\n.filterContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n\r\n    height: 100%;\r\n    width: 100%;\r\n\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n    padding-right: 0;\r\n}\r\n\r\n.filterIonSelect {\r\n    justify-content: center;\r\n    align-items: center;\r\n    --padding-start: var(--spacing-xx-small);\r\n    --padding-end: var(--spacing-xx-small);\r\n    --padding-top: 0;\r\n    --padding-bottom: 0;\r\n    --width: auto;\r\n}\r\n\r\n.filterIonSelect .popover-content {\r\n    width: auto;\r\n}\r\n\r\n.centerContent {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.custom-outline {\r\n    height: 70% !important;\r\n    border: 1px solid var(--af-border-primary);\r\n    border-radius: var(--af-radius-item);\r\n    padding: 0 var(--spacing-xx-small);\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.filter-item-title {\r\n    margin: 0 var(--spacing-xx-small);\r\n    font-size: clamp(0.2rem, 1.8vmin, 0.9rem);\r\n    color: black;\r\n}\r\n\r\n.apply-filter-button {\r\n    height: 65% !important;\r\n    border-radius: var(--af-radius-item);\r\n    background-color: var(--ion-color-primary);\r\n    margin-left: var(--spacing-xx-small);\r\n    min-width: 38px !important;\r\n    width: auto;\r\n    padding: 0 var(--spacing-xx-small);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border: 2px solid transparent !important;\r\n    transition: all 0.3s ease;\r\n    cursor: pointer;\r\n    color: white !important;\r\n\r\n    ion-icon {\r\n        color: white !important;\r\n        font-size: 14px !important;\r\n    }\r\n\r\n    ion-label {\r\n        color: white !important;\r\n    }\r\n\r\n    &:hover {\r\n        border: 2px solid var(--ion-color-primary) !important;\r\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n        color: var(--ion-color-primary);\r\n        background-color: white;\r\n\r\n        ion-icon,\r\n        ion-label {\r\n            color: var(--ion-color-primary) !important;\r\n        }\r\n    }\r\n\r\n    &:active {\r\n        transform: scale(0.98);\r\n    }\r\n}\r\n\r\n.select-filter-button {\r\n    opacity: 1;\r\n    position: absolute;\r\n    z-index: 990;\r\n\r\n    width: auto;\r\n    min-width: 45px !important;\r\n    max-width: 150px;\r\n    min-height: 15px !important;\r\n    height: 100% !important;\r\n    padding: 0 var(--spacing-xx-small) !important;\r\n\r\n    right: var(--spacing-small);\r\n\r\n    border-radius: var(--af-radius-section);\r\n    background-color: var(--ion-color-primary);\r\n    border: 2px solid transparent !important;\r\n\r\n    margin-left: auto;\r\n    margin-right: 0;\r\n    transition: all 0.3s ease;\r\n    cursor: pointer;\r\n    color: white;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-small);\r\n\r\n    ion-icon {\r\n        color: white !important;\r\n        font-size: 22px !important;\r\n    }\r\n\r\n    ion-label {\r\n        color: white !important;\r\n    }\r\n\r\n    &:hover {\r\n        border: 2px solid var(--ion-color-primary) !important;\r\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n        color: var(--ion-color-primary);\r\n        background-color: white;\r\n\r\n        ion-icon,\r\n        ion-label {\r\n            color: var(--ion-color-primary) !important;\r\n        }\r\n    }\r\n\r\n    &:active {\r\n        transform: scale(0.98);\r\n    }\r\n}\r\n\r\noption {\r\n    color: var(--ion-color-primary);\r\n    background-color: white;\r\n    padding: 8px;\r\n}\r\n\r\n.custom-select-popover-filter,\r\n.custom-select-popover-num-months-years,\r\n.custom-select-popover-year {\r\n  height: 70% !important;\r\n  width: auto;\r\n  background-color: white !important;\r\n  color: var(--ion-color-primary) !important;\r\n  border: 1px solid var(--ion-color-primary);\r\n  border-radius: var(--af-radius-item);\r\n  padding: 0 var(--spacing-xx-small);\r\n  margin: 0 var(--spacing-xx-small) 0 var(--spacing-xx-small);\r\n  font-size: clamp(0.2rem, 1.8vmin, 0.9rem);\r\n}\r\n\r\n.popover-filter-container {\r\n    padding: var(--spacing-large);\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n    border-radius: 0;\r\n    gap: var(--spacing-medium);\r\n    justify-content: space-between;\r\n\r\n  .filter-controls-row {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    padding: var(--spacing-xs);\r\n    border-bottom: 1px solid #f0f0f0;\r\n\r\n    .filter-item-title {\r\n      min-width: auto;\r\n      max-width: none;\r\n      color: var(--ion-color-primary);\r\n      white-space: nowrap;\r\n      overflow: visible;\r\n      text-overflow: initial;\r\n      font-size: clamp(0.8rem, 1.5vw, 1rem);\r\n      margin: 0;\r\n      flex-shrink: 0;\r\n      font-weight: 500;\r\n    }\r\n\r\n    select {\r\n      background-color: white;\r\n      color: var(--ion-color-primary);\r\n      border: 1px solid var(--ion-color-primary);\r\n      border-radius: var(--af-radius-item);\r\n      padding: var(--spacing-xs) var(--spacing-small);\r\n      height: 44px;\r\n      margin: 0;\r\n      font-size: 1rem;\r\n      min-width: 120px;\r\n      flex-grow: 1;\r\n      margin-left: var(--spacing-small);\r\n    }\r\n  }\r\n\r\n  .filter-button-row {\r\n    display: flex;\r\n    justify-content: center;\r\n    padding-top: var(--spacing-xs);\r\n    width: 100%;\r\n\r\n    .apply-filter-button {\r\n      height: 44px !important;\r\n      border-radius: var(--af-radius-item);\r\n      margin-top: 0;\r\n      width: 100%;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      padding: 0 var(--spacing-small) !important;\r\n\r\n      .apply-filter-label {\r\n        display: block !important;\r\n        color: white;\r\n        font-size: 0.9rem;\r\n        margin: 0;\r\n        padding: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n::ng-deep .filter-popover {\r\n    --width: 100vw !important;\r\n    --height: 100vh !important;\r\n    --max-width: 100vw !important;\r\n    --max-height: 100vh !important;\r\n    \r\n    .popover-content {\r\n        width: 100vw !important;\r\n        height: 100vh !important;\r\n        max-width: 100vw !important;\r\n        max-height: 100vh !important;\r\n    }\r\n}\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n/*#region Small Screens*/\r\n\r\n  /* Styles for screens smaller than 800px wide or 550 high */\r\n  @media (max-width: 800px) or (max-height: 550px) {\r\n    .filterContainer {\r\n        display: none;\r\n    }\r\n\r\n    .apply-filter-label {\r\n        display: none;\r\n    }\r\n\r\n    .filter-item-title {\r\n        max-width: 25px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .chip-icon {\r\n        margin: 0;\r\n        height: 80%;\r\n        width: 80%;\r\n    }\r\n\r\n    .select-filter-button {\r\n        display: flex;\r\n    }\r\n  }\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min with of 800px and min height of 550px */\r\n  @media (min-width: 800px) and (min-height: 550px) {\r\n    .chip-icon {\r\n        display: none !important;\r\n    }\r\n\r\n    .select-filter-button {\r\n        display: none !important;\r\n    }\r\n  }\r\n\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n\r\n  /* Styles for screens larger than 1000px wide and 600px high */\r\n  @media (min-width: 1000px) and (min-height: 600px) {\r\n    .chip-icon {\r\n        display: none !important;\r\n    }\r\n\r\n    .select-filter-button {\r\n        display: none !important;\r\n    }\r\n  }\r\n\r\n/*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
